import { Link } from "react-router-dom";
import { useState } from "react";
import ComingSoonModal from "../../components/coming_soon_modal.jsx";
import PayStagingPlanModal from "./pay_staging_plan_modal.jsx";

var mockData = [
  {
    project_api_plan_id: "devApiPlanId1",
    project_id: "projIdStr",
    project_name: "Sandbox Plan",
    api_plan_duration: 30,
    fixed_rate: 0,
    variable_rate: 0.00,
    api_plan_description: "1 Sandbox Project Per Developer Account",
    is_deleted: 0,
    project_api_plan_environment: "staging",
    features: [
      "1 Sandbox Project Per Developer Account",
      "NETS Online Payment APIs",
      {
        title: "Supported Payment Methods",
        items: ["eNETS", "NETS Click", "NETS QR"],
      },
    ],
  },
  {
    project_api_plan_id: "devApiPlanId2",
    project_id: "projId2Str",
    project_name: "Explorer Plan",
    api_plan_duration: 30,
    fixed_rate: 20,
    variable_rate: 1.50,
    api_plan_description: "Up to 5,000 API calls per month",
    is_deleted: 0,
    project_api_plan_environment: "staging",
    features: [
      "Up to 5,000 API calls per month",
      "OPENAPIPAAS Testbed Server APIs",
      {
        title: "Includes",
        items: ["Lookup Product Web Services", "Omnichannel Transaction Web Services"],
      },
      "NETS Online Payment APIs (UAT Environment)",
      {
        title: "Supported Payment Methods",
        items: ["eNETS", "NETS Click", "NETS QR"],
      },
    ],
  },
  {
    project_api_plan_id: "devApiPlanId3",
    project_id: "projId2Str",
    project_name: "Professional Plan",
    api_plan_duration: 30,
    fixed_rate: 100,
    variable_rate: 2.00,
    api_plan_description: "Up to 25,000 API calls per month",
    is_deleted: 0,
    project_api_plan_environment: "staging",
    features: [
      "Up to 25,000 API calls per month",
      "OPENAPIPAAS Testbed Server APIs",
      {
        title: "Includes",
        items: ["Lookup Product Web Services", "Omnichannel Transaction Web Services"],
      },
      "NETS Online Payment APIs (UAT Environment)",
      {
        title: "Supported Payment Methods",
        items: ["eNETS", "NETS Click", "NETS QR"],
      },
    ],
  },
  {
    project_api_plan_id: "devApiPlanId4",
    project_id: "projId2Str",
    project_name: "Enterprise Plan",
    api_plan_duration: 30,
    fixed_rate: 500,
    variable_rate: 2.50,
    api_plan_description: "Unlimited API calls",
    is_deleted: 0,
    project_api_plan_environment: "staging",
    features: [
      "Unlimited API calls",
      "OPENAPIPAAS Testbed Server APIs",
      {
        title: "Includes",
        items: ["Lookup Product Web Services", "Omnichannel Transaction Web Services"],
      },
      "NETS Online Payment APIs (UAT Environment)",
      {
        title: "Supported Payment Methods",
        items: ["eNETS", "NETS Click", "NETS QR"],
      },
    ],
  },
];

export { mockData };

export default function StagingCatalogueCard({
  planName,
  price = "$0.00",
  billingCycle = "/month",
  features = [],
  isMobile = false,
}) {
  const [isOpen, setOpen] = useState(false);
  const handleComingSoonClick = () => {
    setOpen(true);
  };

  return (
    <div
      className="bg-white border-gray-500 border rounded-2xl text-black"
      style={{
        // Increased height to accommodate all content
        height: isMobile ? "500px" : "650px",
        width: "100%",
        minHeight: isMobile ? "500px" : "650px",
        maxHeight: isMobile ? "500px" : "650px",
        boxShadow: "5px 10px #EBECF0",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className="p-4"
        style={{
          display: "grid",
          "gridTemplateAreas": `'text1 text1 text1' 'text2 text2 text2''text3 text3 text3''text4 text4 text4''button1 button1 button1'`,
          "gridTemplateColumns": "repeat(3, minmax(0, 1fr))",
          "gridTemplateRows": "60px 80px 40px 1fr 60px", // Fixed heights for consistent layout
          gap: 4,
          maxWidth: "inherit",
          textAlign: "left",
          height: "100%",
        }}
      >
        {/* Plan Name - Fixed height */}
        <div 
          className="font-bold text-gray-700" 
          style={{ 
            gridArea: "text1", 
            fontSize: isMobile ? "22px" : "28px",
            height: "60px",
            display: "flex",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          {planName}
        </div>

        {/* Price - Fixed height */}
        <div 
          className="font-bold" 
          style={{ 
            gridArea: "text2",
            fontSize: isMobile ? "30px" : "34px",
            height: "80px",
            display: "flex",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          ${price}
        </div>

        {/* Billing Cycle - Fixed height */}
        <div 
          className="font-bold text-gray-500" 
          style={{ 
            gridArea: "text3",
            fontSize: isMobile ? "16px" : "18px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          {billingCycle}
        </div>

        {/* Features - Flexible height with scroll if needed */}
        <div 
          className="text-black" 
          style={{ 
            gridArea: "text4",
            fontSize: isMobile ? "13px" : "15px",
            overflowY: "auto", // Allow vertical scrolling if content is too long
            overflowX: "hidden",
            paddingRight: "8px", // Space for scrollbar
            maxHeight: "100%"
          }}
        >
          <ul style={{ 
            listStyleType: "circle", 
            paddingLeft: "20px",
            margin: "0",
            lineHeight: "1.4"
          }}>
            {features.map((feature, index) => (
              typeof feature === "object" ? (
                <li key={index} style={{ marginBottom: "8px" }}>
                  <strong style={{ fontSize: isMobile ? "13px" : "15px" }}>
                    {feature.title}
                  </strong>
                  <ul style={{ 
                    listStyleType: "disc", 
                    paddingLeft: "15px",
                    marginTop: "4px"
                  }}>
                    {feature.items.map((subFeature, subIndex) => (
                      <li key={subIndex} style={{ 
                        fontSize: isMobile ? "12px" : "14px",
                        marginBottom: "2px"
                      }}>
                        {subFeature}
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={index} style={{ 
                  marginBottom: "8px",
                  fontSize: isMobile ? "13px" : "15px"
                }}>
                  {feature}
                </li>
              )
            ))}
          </ul>
        </div>

        {/* Button Container - Fixed height */}
        <div 
          className="button-container" 
          style={{ 
            gridArea: "button1", 
            textAlign: "center",
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <button
            type="button"
            onClick={handleComingSoonClick}
            className="hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 py-2 px-12 rounded-full text-sm"
            style={{ 
              textAlign: "center", 
              width: "80%",
              fontSize: isMobile ? "14px" : "16px",
              padding: isMobile ? "8px 16px" : "10px 24px"
            }}
          >
            Get Started Today
          </button>
        </div>
      </div>

      {isOpen && <PayStagingPlanModal setOpenModal={setOpen} />}
    </div>
  );
}